import angular from "angular";

angular
    .module('app')
    .component('ordersControl', {
        template: require('./orders-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', 'moment', '$httpParamSerializer', controller],
        bindings: {
            courses: '<'
        }
    });

function controller($uibModal, Notifier, $http, moment, $httpParamSerializer) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '20';

    $ctrl.isCancel = false;
    $ctrl.course = null;
    $ctrl.paymentType = null;
    $ctrl.student = null;
    $ctrl.startDate = null;
    $ctrl.endDate = null;

    $ctrl.orderBy = 'date';
    $ctrl.orderDir = 'desc';

    $ctrl.querySerializer = null;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };



    $ctrl.getList = function () {
        let params = {
            page: $ctrl.page,
            per_page: $ctrl.perPage,
        };

        let queryParams = {
            payment_type: $ctrl.paymentType,
            is_cancel: +$ctrl.isCancel,
            course_id: $ctrl.course ? $ctrl.course.id : null,
            student_id: $ctrl.student ? $ctrl.student.id : null,
            start_date: $ctrl.startDate ? moment($ctrl.startDate).format('YYYY-MM-DD') : null,
            end_date: $ctrl.endDate ? moment($ctrl.endDate).format('YYYY-MM-DD') : null,

            order_by: $ctrl.orderBy,
            order_dir: $ctrl.orderDir,
        };

        $ctrl.querySerializer = $httpParamSerializer(queryParams);

        $http
            .get('/admin/orders/get-list', {
                params: Object.assign({}, params, queryParams)
            })
            .then(
                function (response) {

                    let res = response.data.result;
                    $ctrl.orders = res.data;
                    $ctrl.total = res.total;
                    $ctrl.sum =  response.data.sum;
                },
                function (error) {
                }
            );
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.resetFilter = function () {
        $ctrl.page = 1;
        $ctrl.course = null;
        $ctrl.isCancel = null;
        $ctrl.student = null;
        $ctrl.startDate = null;
        $ctrl.endDate = null;
        $ctrl.paymentType = null;
        $ctrl.getList();
    };

    $ctrl.perPageChanged = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }

        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.hideOrder = function (index) {
        const per = confirm('Вы точно хотите удалить?');
        if (!per) {
            return;
        }
        const order = $ctrl.orders[index];
        $http.post('/admin/orders/' + order.id + '/hide').then((res) => {
            if(order.payment_type !== 'free' && !order.is_cancel && order.sum > 0) {
                $ctrl.sum -= order.sum;
            }
            $ctrl.orders.splice(index, 1);
            $ctrl.total--;
        });

    }
}
